import React from 'react';
import Slider from 'react-slick';
import styled from 'styled-components';
import { SimpleImage } from 'components/SimpleImage';

import { Popup, CloseContainer } from 'styles/pages/settings.styles';
import { RemoveIcon } from 'styles/components/card.styles';

interface TotemDeliveryPicturesPopUpProps {
    photos?: { urls: string[] }[] | null;
    setShowPictures: (show: boolean) => void;
}
export const TotemDeliveryPicturesPopUp = ({ photos, setShowPictures }: TotemDeliveryPicturesPopUpProps) => {
    if (!photos) {
        return 'Il y a eu un problème avec ce post.';
    }
    // Safely flatten the urls array
    const photosUrl: string[] = Array.isArray(photos)
        ? photos.flatMap((photoArray) => (Array.isArray(photoArray?.urls) ? photoArray.urls : []))
        : [];
    const renderImages = () =>
        photosUrl.map((url) => (
            <SliderImageWrapper key={url} tabIndex={-1}>
                <SliderImageContent photo={url} />
            </SliderImageWrapper>
        ));

    const sliderSettings = {
        dots: true,
        arrows: true,
        dotsClass: 'slider-dots',
        focusOnSelect: true,
        customPaging: (i: number) => (
            <button
                type="button"
                tabIndex={0}
                style={{ background: 'none', border: 'none', padding: 0, margin: 0, cursor: 'pointer' }}
            >
                <SimpleImage src={photosUrl[i]} alt="delivery-picture" width={100} />
            </button>
        ),
    };

    const stopPropagation = (e: React.MouseEvent<HTMLDivElement>) => {
        e.nativeEvent.stopImmediatePropagation();
        e.stopPropagation();
    };

    return (
        <Popup $alignItems="center" $justifyContent="center" onClick={() => setShowPictures(false)}>
            <SliderContainer onClick={stopPropagation}>
                <Slider {...sliderSettings}>{renderImages()}</Slider>
                <CloseContainer top="-20px" right="-20px">
                    <RemoveIcon size="30px" onClick={() => setShowPictures(false)} />
                </CloseContainer>
            </SliderContainer>
        </Popup>
    );
};

export const SliderImageWrapper = styled.div`
    position: relative;
    outline: 0;
    background-color: transparent;
    border-radius: ${(props) => props.theme.variables.borderRadius};
`;
type SliderImageContentProps = {
    photo: string;
};
export const SliderImageContent = styled.div<SliderImageContentProps>`
    width: 75vw;
    height: 65vh;
    background: url(${({ photo }) => photo}) no-repeat center center / contain;
`;
export const SliderContainer = styled.div`
    position: relative;
    width: 75vw;

    .slick-slider {
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .slick-list {
        width: 100%;
    }

    .slick-slide {
        opacity: 0;
        display: inline-block;

        &.slick-active.slick-current {
            opacity: 1;
        }
    }

    .slick-arrow {
        z-index: 1;

        &:before {
            font-family: inherit;
            color: white;
            font-size: 35px;
            font-weight: 500;
            opacity: 1;
        }

        &:hover {
            &:before {
                color: ${(props) => props.theme.colors.yellow};
            }
        }
    }

    .slick-prev {
        left: -40px;
    }

    .slick-next {
        right: -40px;
    }

    .slider-dots {
        position: relative;
        padding: 0;
        margin-top: 20px;
        text-align: center;
        list-style-type: none;

        > li {
            position: relative;
            display: inline-block;
            width: 50px;
            height: 50px;
            margin: 0 5px;
            overflow: hidden;
            border-radius: ${(props) => props.theme.variables.borderRadius};
            cursor: pointer;
            opacity: 0.75;
            transition: all 0.5s ease;

            &:hover,
            &.slick-active {
                opacity: 1;
            }

            &.slick-active {
                border: 2px solid ${(props) => props.theme.colors.yellow};
            }

            > img {
                position: absolute;
                top: 50%;
                left: 50%;
                background: transparent no-repeat center / cover;
                transform: translate(-50%, -50%);
            }
        }
    }
`;
